/* Halcyra — Shift Club interactions */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const TIERS = [[2, 15], [3, 20], [4, 25], [5, 30]];
const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

function sectionIds() {
  return [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
}

/** Add lines to cart and let the theme's cart drawer react. */
export async function scAdd(lines, source = document.body) {
  const deferred = CartLinesUpdateEvent.createPromise();
  const itemCount = lines.reduce((n, l) => n + (l.quantity || 1), 0);
  source.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity || 1 })),
    promise: deferred.promise,
  }));
  try {
    const res = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map((l) => ({ id: Number(l.id), quantity: l.quantity || 1 })), sections: sectionIds().join(',') }),
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message || 'Add failed');
    const cart = await fetch(ROOT + 'cart.js').then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'sc', sourceId: 'sc', itemCount, sections: data.sections, didError: false },
    });
    updateWeek(cart.item_count);
    return cart;
  } catch (err) {
    deferred.reject(err);
    console.warn('[sc] add failed, falling back to cart page', err);
    window.location.href = ROOT + 'cart';
  }
}

function tierFor(count) {
  let pct = 0;
  for (const [q, p] of TIERS) if (count >= q) pct = p;
  return pct;
}

function updateWeek(count) {
  document.querySelectorAll('[data-sc-week]').forEach((box) => {
    const preview = box.hasAttribute('data-sc-week-preview') ? 1 : 0;
    const filled = Math.min(5, count);
    box.querySelectorAll('[data-sc-slot]').forEach((slot, i) => {
      slot.classList.toggle('is-filled', i < filled);
      slot.classList.toggle('is-next', !!preview && i === filled);
    });
    const bar = box.querySelector('[data-sc-bar]');
    if (bar) bar.style.width = Math.min(100, ((filled + preview) / 5) * 100) + '%';
    const msg = box.querySelector('[data-sc-msg]');
    if (msg) {
      const after = count + preview;
      const now = tierFor(after);
      if (after >= 5) {
        msg.innerHTML = '<b>30% unlocked</b> — every piece drops to $17.50 at checkout.';
      } else {
        const need = 5 - after;
        const lead = preview ? (now ? '<b>' + now + '% off</b> with this one. ' : '') : (count ? 'You have <b>' + count + '</b> in your bag' + (now ? ' (' + now + '% off). ' : '. ') : '');
        msg.innerHTML = lead + 'Add <b>' + need + ' more</b> to unlock <b>30% off everything</b> — 5 pieces for $87.50.';
      }
    }
    const c = box.querySelector('[data-sc-count]');
    if (c) c.textContent = Math.min(5, count + preview) + ' OF 5';
  });
}

const evName = (StandardEvents && StandardEvents.cartLinesUpdate) || 'cart:lines-update';
document.addEventListener(evName, (e) => {
  const p = e.promise;
  if (!p || !p.then) return;
  p.then(() => fetch(ROOT + 'cart.js').then((r) => r.json()).then((c) => updateWeek(c.item_count))).catch(() => {});
});

function selectedSize() {
  const checked = document.querySelector('.variant-picker input[type="radio"]:checked');
  if (checked) return (checked.value || '').trim();
  const sel = document.querySelector('.variant-picker select');
  return sel ? sel.value : null;
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-sc-add]');
  if (!btn) return;
  e.preventDefault();
  let map = {};
  try { map = JSON.parse(btn.getAttribute('data-sc-add') || '{}'); } catch (_) {}
  const size = selectedSize();
  const ids = [];
  for (const group of (map.groups || [])) {
    const id = (size && group[size]) || group.M || Object.values(group)[0];
    if (id) ids.push({ id, quantity: 1 });
  }
  if (!ids.length) return;
  const label = btn.innerHTML;
  btn.setAttribute('aria-busy', 'true');
  btn.textContent = 'Adding…';
  await scAdd(ids, btn);
  btn.innerHTML = label;
  btn.removeAttribute('aria-busy');
});

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-sc-open]');
  if (opener) {
    e.preventDefault();
    const d = document.getElementById(opener.dataset.scOpen);
    if (d && d.showModal) d.showModal();
  }
  const closer = e.target.closest('[data-sc-close]');
  if (closer) { const d = closer.closest('dialog'); if (d) d.close(); }
});

const SIZES = ['S', 'M', 'L', 'XL', 'XXL'];
document.addEventListener('change', (e) => {
  const form = e.target.closest('[data-sc-fit]');
  if (form) {
    const usual = Number(form.querySelector('[name="usual"]').value);
    const room = Number(form.querySelector('[name="room"]').value);
    const idx = Math.max(0, Math.min(4, usual + room));
    form.querySelector('[data-sc-fit-out]').textContent = SIZES[idx];
  }
  const sel = e.target.closest('[data-sc-sort]');
  if (sel) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url.toString();
  }
});

document.addEventListener('click', (e) => {
  const chip = e.target.closest('[data-sc-filter]');
  if (!chip) return;
  const scope = chip.closest('[data-sc-filter-scope]');
  const fam = chip.dataset.scFilter;
  scope.querySelectorAll('[data-sc-filter]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
  scope.querySelectorAll('[data-family]').forEach((card) => { card.hidden = fam !== 'all' && card.dataset.family !== fam; });
  scope.querySelectorAll('[data-sc-promo]').forEach((t) => { t.hidden = fam !== 'all'; });
});

fetch(ROOT + 'cart.js').then((r) => r.json()).then((c) => updateWeek(c.item_count)).catch(() => {});
